import axios from "@/axios";

const fetchFooterFieldTypes = async () => {
  try {
    const url = `fields/types`;
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const fetchFooterFieldOption = async (id, field_type)  => {
 try {
    const url = `fields/${id}/all?page=1&&count=100&field_type=${field_type}&special_fields=false`;
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
}

const saveFooterFields = async (payload) => {
  try {
    const url = `fields/save`;
    const { data } = await axios.post(url, payload);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const fetchFooterFields = async (userType, id) => {
  try {
    const url = `fields/${userType}/${id}`;
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
}

// https://vanilla.neotas.co/api/v1/fields/cfeafc20-2b20-4499-93d0-c069f2c237da/all?page=1&&count=10&field_type=b769c5d1-8147-41e7-8d0c-022c6841c03d&special_fields=false

export {
    fetchFooterFieldTypes,
    fetchFooterFieldOption,
    saveFooterFields,
    fetchFooterFields,
}